import { Component, OnInit } from '@angular/core';
import { ErrorService } from 'src/app/shared/services/error.service';
import { FileAccessService } from 'src/app/shared/services/fileaccess.service';
import { File } from '../../shared/model/files';
import FileSaver from 'file-saver';

@Component({
  selector: 'app-reports-static',
  templateUrl: './reports-static.component.html',
  styleUrls: ['./reports-static.component.scss']
})
export class ReportsStaticComponent implements OnInit {

  selectedReportType: string;

  serviceReports: any[];
  csocReports: any[];
  certReports: any[];
  otherReports: any[];

  selectedReports: any[];

  filesList: File[];
  fileNames: string[];
  fileStructure: {};
  
  currentPath: string[];
  viewedFileStructure: {};
  loading: boolean;

  constructor(private fileAccessService: FileAccessService, private errorService: ErrorService) { }

  ngOnInit() {
    this.fileNames = [];
    this.currentPath = [];
    this.loading = true;
    
    this.fileAccessService.getFilesList()
      .then(res => {
        this.filesList = res;
      })
      .then(() => {
        // sort files by recently created
        this.filesList = this.filesList.sort((f1, f2) => (f1.created > f2.created) ? -1 : 1);
      })
      .then(() => {
        //create array of file names
        this.filesList.map(a => this.fileNames.push(a.title));
      })
      .then(() => {
        // create folder heirarchy for display
        let fa = this.fileNames;
        var obj = {}
        fa.forEach(function(path) {
          if(!path.endsWith("/")){
            path.split('/').reduce(function(r, e) {
              return r[e] || (r[e] = {})
            }, obj)
          }
        })
        this.fileStructure = obj;
        this.viewedFileStructure = JSON.parse(JSON.stringify(this.fileStructure));
        this.loading = false;
      })
      .catch(err => {
        this.handlerError(err);
      })

  }

  downloadFile(currentPath: [], fileName: string): void { 
    let ff = this.filesList.filter(f => f.title = fileName)[0];
    
    if(ff){
      let newFile = this.getFilePath(currentPath, ff.title);
      this.fileAccessService.downloadFile(newFile)
        .subscribe(val => {
          var file = new Blob([val], {type: ff.contentType});
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file);
          }else {
            FileSaver.saveAs(file, fileName.substring(fileName.lastIndexOf('/')+1));
          }
      }), 
      error => console.log('Error downloading the file'),
      () => console.info('File downloaded successfully');
    }else{
      this.errorService.handlerError("File failed to download, please try again or contact support");
    }
  }


  fullResetPath(){
    this.currentPath = [];
    this.viewedFileStructure = JSON.parse(JSON.stringify(this.fileStructure));
  }

  resetPath(index: number){
    this.currentPath = this.currentPath.slice(0,index+1);
    this.viewedFileStructure = JSON.parse(JSON.stringify(this.fileStructure));
    this.currentPath.forEach(cp => {
      this.viewedFileStructure = this.viewedFileStructure[cp];
    })
  }

  openFolder(key: string){
    this.currentPath.push(key);
    this.viewedFileStructure = JSON.parse(JSON.stringify(this.fileStructure));
    this.currentPath.forEach(cp => {
      this.viewedFileStructure = this.viewedFileStructure[cp];
    })
  }

  /**
   * Error handling forwarder, only not going direct so 
   * it allows us to add context within this module
   * @param err 
   */
  private handlerError(err){
    this.errorService.handlerError(err);
  }

  private originalOrder = (a: any, b: any): number => {
    return 0;
  }

  /**
   * Creates the full (bucket) path from the current folder path and clicked filename
   */
  getFilePath(folderPath, filename) {
    if (folderPath.length > 0) {
      return folderPath.join("/") + "/" + filename;
    } else {
      // no leading forwardslash
      return filename;
    }
  }
}